import ReactionSearchPanelContainer from './RedactionSearchPanelContainer';

export default ReactionSearchPanelContainer;